import script from "./CurrentTillDate.vue?vue&type=script&setup=true&lang=js"
export * from "./CurrentTillDate.vue?vue&type=script&setup=true&lang=js"

import "./CurrentTillDate.vue?vue&type=style&index=0&id=c14108fe&lang=css"

const __exports__ = script;

export default __exports__